<template>
  <div class="">
    <modal :show.sync="editModal" header-classes="bg-primary p-3" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        Caregiver Saathi
      </h6>
      <div>
        <p class="mt-2 input-title-black">By submitting this form:</p>
        <p class="mt-2 input-title-black">
          1) You let Caregiver Saathi and its partners use this data for
          insights and analytics. You are not flooded with unnecessary
          information, and it enables us to send you more relevant information
          and resources to support you.
        </p>
        <p class="mt-2 input-title-black">
          2) You agree to be contacted with information and future programs,
          events,promotions, pertaining to the areas of interest you have
          specified in this form.
        </p>
      </div>
      <template slot="footer">
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <b-modal
      id="vendorRegister"
      size=""
      centered
      hide-header
      modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey flex justify-center"
      hide-footer
      class="overflow-y-hidden"
    >
      <div class="text-center text-black fsize25px font-medium header-font">
        <h1>Register as a Vendor!</h1>
      </div>
      <div class="border-review-modal space-border">
        <div class="text-center py-5 fsize20px font-medium text-opax">
          <h3>
            Kindly provide the necessary vendor details , these are essential
            for your registration as a vendor.
          </h3>
        </div>
      </div>
      <!-- <a
        href="mailto:info@caregiversaathi.co.in?subject=Verification%20of%20your%20account%20information&body=In%20order%20to%20register%20as%20a%20vendor,%20we%20kindly%20request%20you%20to%20provide%20the%20following%20details%20associated%20with%20your%20account:%20%0D%0AFirst_name:%20%0D%0ALast_name:%20%0D%0AEmail:%20%0D%0AMobile_No:%20%0D%0ABrand_Name:%20%0D%0AAccount_Number:%20%0D%0AGST_No:%20%0D%0AIFSC_Code:%20%0D%0AOnce%20we%20receive%20the%20information%20we%20will%20verify%20it%20promptly.%20We'll%20confirm%20your%20registration%20post%20verification."
        class="py-5 flex justify-center"
      > -->
      <div class="py-5 flex justify-center">
        <b-button variant="primary" @click="vendorRedirect">Proceed</b-button>
      </div>
      <!-- </a> -->
    </b-modal>
    <div class="relative lg:pt-32 md:pt-32 pt-20 bg-white">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute top-32 right-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/career-dots.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute bg-designreg2 left-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/career-dots.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute bottom-32 right-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/CD-dots2.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
        <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
      </div>
      <div class="absolute top-1/2 left-20 md:block lg:block hidden">
        <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
      </div>
      <div class="lg:flex md:flex gap-16 lg:px-10 md:px-10 px-5">
        <div class="lg:w-4/6 md:w-4/6 justify-center items-center mob-hidden">
          <h2 class="fsize48 font-bold subtitle pl-32">Welcome to</h2>
          <span class="fsize48 font-bold text-primary pl-32"
            >Caregiver Saathi</span
          >
          <p class="fsize20 pl-32">
            A registered user gets access to curated content under Insights,
            Blogs, Podcasts, and many more.
          </p>
          <p class="fsize20 pl-32">
            Subscribers will get personalized content.
          </p>
          <div class="pt-5">
            <div
              class="font-normal text-center fsize20 md-fsize25 fsize36-16px text-black md:px-0 lg:px-0 px-6"
            >
              Download App
            </div>
            <div
              class="flex justify-center md:pt-0 lg:pt-0 pt-2 md:pl-0 lg:pl-0 pl-4"
            >
              <a
                href="https://play.google.com/store/apps/details?id=com.ceraproject"
                alt="playstore"
                target="_blank"
                class="contents"
              >
                <img
                  src="@/assets/images/appstore.svg"
                  alt="Download"
                  class="md:h-14 lg:h-5 h-auto mx-2 md:w-auto lg:w-40 w-1/3 md-w-130px"
                />
              </a>
              <a
                href="https://apps.apple.com/in/app/caregiver-saathi/id1640805488"
                alt="playstore"
                target="_blank"
                class="contents"
              >
                <img
                  src="@/assets/images/istore.svg"
                  alt="Download"
                  class="md:h-14 lg:h-5 h-auto mx-2 md:w-auto lg:w-40 w-1/3 md-w-130px"
                />
              </a>
            </div>
          </div>
          <!-- src="@/assets/images/coach/OnlineLEARN.png" -->
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/banner-latino-indian-man-woman-couple-use-their-laptop-living-room-make-video-calls-copy-space-video.jpg"
            alt=""
            class="object-contain w-full h-360px"
          />
        </div>
        <card class="shadow-lg lg:w-1/2 md:w-1/2 w-full">
          <div class="mx-auto">
            <p class="fsize25 font-semibold text-center text-black">Register</p>
            <p class="subtitle tracking-wide text-center fsize14px">
              Already have an account?
              <span
                @click="handlesignin()"
                class="lg:ml-2 md:ml-2 ml-4 font-bold text-primary underline cursor-pointer"
                >Sign In</span
              >
            </p>
            <p class="subtitle tracking-wide text-center fsize14px">
              Want to register as Vendor?
              <span
                class="lg:ml-2 md:ml-2 ml-4 font-bold text-primary underline cursor-pointer"
                @click="vendorRedirect"
                >Click Here</span
              >
              <!-- v-b-modal.vendorRegister -->
            </p>
            <!-- <div class="w-full">
              <div class="pt-4 relative">
                <p class="fsize14 input-title-black">
                  Want to register as Vendor? Provide your details
                  <u class="cursor-pointer ublue font-semibold">
                    <a href="mailto:info@caregiversaathi.co.in"> here</a></u
                  >
                </p>
              </div>
            </div> -->

            <!--     <div class="mt-10">
          <b-tabs content-class="" justified class="root cust-of">
            <b-tab active class="helo cust-width"
              ><template #title>
                <div class="p-1 my-auto">
                  <p class="pt-1 font-semibold fsize14-12px">Caregiver</p>
                </div>
              </template>
          <div class="md:pt-10 lg:pt-10 pt-8">
                <b-tabs content-class="" justified class="root-il cust-of">
                  <b-tab active class="helo cust-width"
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Free</p>
                      </div>
                    </template>
                    <div class="md:pt-10 lg:pt-10 pt-6">
                      <p class="mc-subtitle">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Tincidunt nisl vitae vivamus euismod dolor morbi vel
                        lobortis. Neque porttitor massa felis, lacinia. Eget sed
                        semper viverra orci non ut. Massa enim integer nec donec
                        odi.
                      </p>
                      <div class="pt-4 w-full">
                        <div class="flex flex-wrap">
                          <div class="md:lg:w-1/3 w-full lg:lg:w-1/3 w-full w-full pt-4">
                            <p class="input-title-black">Email Address</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your EmailID"
                              class="border-primary mt-1 shadow-md"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:ml-4
                              lg:ml-4
                              ml-0
                              mt-4
                              md:lg:w-1/3 w-full
                              lg:lg:w-1/3 w-full
                              w-full
                            "
                          >
                            <p class="input-title-black">Password</p>
                            <b-form-input
                              v-model="text"
                              placeholder="xxxxxxxx"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                        </div>
                        <base-button
                          type="primary"
                          class="
                            md:px-10
                            lg:px-10
                            px-6
                            md:py-2
                            lg:py-2
                            py-1
                            border-2
                            text-base
                            font-bold
                            mt-6
                          "
                          >Register</base-button
                        >
                      </div>
                    </div>
                  </b-tab>
                  <b-tab
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Basic</p>
                      </div>
                    </template>
                  </b-tab>
                  <b-tab
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Premium</p>
                      </div>
                    </template>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
            <b-tab
              ><template #title>
                <div class="p-1 my-auto">
                  <p class="pt-1 font-semibold fsize14-12px">Well-wisher</p>
                </div>
              </template>
              <div class="md:pt-10 lg:pt-10 pt-8">
                <b-tabs content-class="" justified class="root-il cust-of">
                  <b-tab active class="helo cust-width"
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Free</p>
                      </div>
                    </template>
                    <div class="md:pt-10 lg:pt-10 pt-6">
                      <p class="mc-subtitle">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Tincidunt nisl vitae vivamus euismod dolor morbi vel
                        lobortis. Neque porttitor massa felis, lacinia. Eget sed
                        semper viverra orci non ut. Massa enim integer nec donec
                        odi.
                      </p>
                      <div class="pt-4 w-full">
                        <div class="flex flex-wrap">
                          <div class="md:lg:w-1/3 w-full lg:lg:w-1/3 w-full w-full pt-4">
                            <p class="input-title-black">Email Address</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your EmailID"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:pl-4
                              lg:pl-4
                              ml-0
                              pt-4
                              md:lg:w-1/3 w-full
                              lg:lg:w-1/3 w-full
                              w-full
                            "
                          >
                            <p class="input-title-black">Password</p>
                            <b-form-input
                              v-model="text"
                              placeholder="xxxxxxxx"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:pl-4
                              lg:pl-4
                              pl-0
                              pt-4
                              md:lg:w-1/3 w-full
                              lg:lg:w-1/3 w-full
                              w-full
                            "
                          >
                            <p class="input-title-black">
                              Caregiver Email Address
                            </p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your Caregiver EmailID"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                        </div>
                        <base-button
                          type="primary"
                          class="
                            md:px-10
                            lg:px-10
                            px-6
                            md:py-2
                            lg:py-2
                            py-1
                            border-2
                            text-base
                            font-bold
                            mt-6
                          "
                          >Register</base-button
                        >
                      </div>
                    </div>
                  </b-tab>
                  <b-tab
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Premium</p>
                      </div>
                    </template>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
            <b-tab
              ><template #title>
                <div class="p-1 my-auto">
                  <p class="pt-1 font-semibold fsize14-12px">
                    Healthcare Proffesionals
                  </p>
                </div>
              </template>
              <div class="md:pt-10 lg:pt-10 pt-8">
                <b-tabs content-class="" justified class="root-il cust-of">
                  <b-tab active class="helo cust-width"
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Paid Plan</p>
                      </div>
                    </template>
                    <div class="md:pt-10 lg:pt-10 pt-6">
                      <p class="mc-subtitle">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Tincidunt nisl vitae vivamus euismod dolor morbi vel
                        lobortis. Neque porttitor massa felis, lacinia. Eget sed
                        semper viverra orci non ut. Massa enim integer nec donec
                        odi.
                      </p>
                      <div class="pt-4 w-full">
                        <div class="flex flex-wrap">
                          <div class="md:lg:w-1/3 w-full lg:lg:w-1/3 w-full w-full pt-4">
                            <p class="input-title-black">Email Address</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your EmailID"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:ml-4
                              lg:ml-4
                              ml-0
                              mt-4
                              md:lg:w-1/3 w-full
                              lg:lg:w-1/3 w-full
                              w-full
                            "
                          >
                            <p class="input-title-black">Password</p>
                            <b-form-input
                              v-model="text"
                              placeholder="xxxxxxxx"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                        </div>
                        <base-button
                          type="primary"
                          class="
                            md:px-10
                            lg:px-10
                            px-6
                            md:py-2
                            lg:py-2
                            py-1
                            border-2
                            text-base
                            font-bold
                            mt-6
                          "
                          >Register</base-button
                        >
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
          </b-tabs>
        </div> -->
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(register)">
                <div class="">
                  <div class="pt-4 w-full">
                    <div class="md:flex">
                      <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                        <p class="fsize14 input-title-black">
                          First Name<span class="text-red-500">*</span>
                        </p>
                        <base-input
                          :rules="{ required: true, alpha: true }"
                          v-model="fname"
                          placeholder="Enter First Name"
                          name="First Name"
                          class="cust-form-border"
                        ></base-input>
                      </div>
                      <div
                        class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full"
                      >
                        <p class="fsize14 input-title-black">
                          Last Name<span class="text-red-500">*</span>
                        </p>
                        <base-input
                          :rules="{ required: true, alpha_dash: true }"
                          name="Last Name"
                          v-model="lname"
                          placeholder="Enter Last Name"
                          class="cust-form-border"
                        ></base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div class="w-full">
                    <div class="md:flex">
                      <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                        <p class="fsize14 input-title-black">
                          Email Address<span class="text-red-500">*</span>
                        </p>
                        <base-input
                          :rules="{ required: true, email: true }"
                          @change="verifyUser('email')"
                          name="Email"
                          v-model="email"
                          placeholder="Enter your EmailID"
                          class="cust-form-border"
                        ></base-input>
                      </div>
                      <div
                        class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full relative"
                      >
                        <p class="fsize14 input-title-black">
                          Password<span class="text-red-500">*</span>
                        </p>
                        <base-input
                          :rules="{ required: true, min: 6 }"
                          name="password"
                          v-model="password"
                          placeholder="xxxxxxxx"
                          class="cust-form-border"
                          :type="passwordFieldType"
                        ></base-input>
                        <div
                          class="absolute flex top-10 right-0"
                          @click="switchVisibility"
                        >
                          <feather-icon
                            icon="EyeOffIcon"
                            svgClasses="w-4 h-4 mr-2 "
                            v-if="passwordFieldType === 'password'"
                          />
                          <feather-icon
                            v-else
                            icon="EyeIcon"
                            svgClasses="w-4 h-4 mr-2 "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div class="w-full flex gap-2 pt-4">
                    <div
                      :class="
                        mobile.length === 10 &&
                        /^\d{10}$/g.test(mobile) &&
                        !userExists
                          ? 'lg:w-3/12 md:w-3/12'
                          : 'md:w-1/4 lg:w-1/4'
                      "
                    >
                      <p class="fsize14 input-title-black">Country Code</p>
                      <vue-country-code
                        defaultCountry="IN"
                        enabledCountryCode
                        @onSelect="handleCountry"
                      >
                      </vue-country-code>
                    </div>
                    <div
                      :class="
                        mobile.length === 10 &&
                        /^\d{10}$/g.test(mobile) &&
                        !userExists
                          ? 'md:w-5/12 lg:w-5/12'
                          : 'md:w-3/4 lg:w-3/4'
                      "
                      class="w-full relative"
                    >
                      <p class="fsize14 input-title-black">
                        Phone<span class="text-red-500">*</span>
                      </p>
                      <base-input
                        @change="verifyUser('mobile')"
                        :rules="{
                          numeric: true,
                          required: true,
                          min: 10,
                          max: 10,
                        }"
                        name="mobile"
                        v-model="mobile"
                        placeholder="Enter your Phone no."
                        class="cust-form-border"
                      ></base-input>
                      <countdown
                        :time="time"
                        v-if="OTPCountdown"
                        @start="handleCountdownStart"
                        @end="handleCountdownEnd"
                      >
                        <template slot-scope="props">
                          <div class="flex items-center">
                            <span class="timer">{{ props.seconds }}</span>
                            <span class="text-sm ml-2">Seconds left </span>
                          </div>
                        </template>
                      </countdown>

                      <!-- <div
                      class="absolute right-4 top-8 cursor-pointer hover:bg-primary hover:text-white text-primary"
                      v-if="
                          mobile.length === 10 &&
                          /^\d{10}$/.test(mobile) &&
                          !userExists
                        "
                      >
                        <p class="" v-if="!OTPCountdown" @click="handleClick">
                          Get OTP
                        </p>
                      </div> -->
                    </div>
                    <div
                      class="md:w-4/12 lg:w-4/12 w-full relative"
                      v-if="
                        mobile.length === 10 &&
                        /^\d{10}$/g.test(mobile) &&
                        !userExists
                      "
                    >
                      <div class="pt-6 float-right">
                        <base-button
                          v-if="!OTPCountdown"
                          type="primary"
                          outline
                          @click="handleClick"
                          class="cust-border"
                          >Generate OTP</base-button
                        >
                      </div>
                    </div>
                  </div>

                  <div class="w-full">
                    <!-- <div class="pt-4 relative" v-if="showOtp"> -->
                    <div class="pt-4 relative">
                      <p class="fsize14 input-title-black">Enter OTP to Verify Email</p>
                      <base-input
                        :rules="{ required: true, numeric: true }"
                        name="otp"
                        v-model="otp"
                        placeholder=""
                        class="cust-form-border"
                      ></base-input>
                    </div>
                  </div>
                </div>
                <!-- <validation-provider
              :rules="{ required: true }"
              name="age"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">Age</p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio v-model="age" name="age" value="15-20"
                      ><p>15-20</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio v-model="age" name="age" value="20-30"
                      ><p>20-30</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio v-model="age" name="age" value="30-50"
                      ><p>30-50</p></b-form-radio
                    >
                  </div>
                   <countdown
                  :time="time"
                  v-if="OTPCountdown"
                  @start="handleCountdownStart"
                  @end="handleCountdownEnd"
                >
                  <template slot-scope="props">
                    <div class="flex items-center pl-2">
                      <span class="timer">{{ props.seconds }}</span>
                      <span class="text-sm ml-2">Seconds left </span>
                    </div>
                  </template>
                </countdown> 
                </div>
                <div class="md:flex mt-4">
                  <div class="w-1/3">
                    <b-form-radio v-model="age" name="age" value="50-70"
                      ><p>50-70</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio v-model="age" name="age" value="More than 70"
                      ><p>More than 70</p></b-form-radio
                    >
                  </div>
                </div>
              </div>
            </validation-provider> -->
                <!-- <validation-provider
              :rules="{ required: true }"
              name="occupation"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">Occupation</p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="occupation"
                      name="occupation"
                      value="Main income provider"
                      ><p>Main income provider</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="occupation"
                      name="occupation"
                      value="Secondary income provider"
                      ><p>Secondary income provider</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="occupation"
                      name="occupation"
                      value="Not working"
                      ><p>Not working</p></b-form-radio
                    >
                  </div>
                </div>
              </div>
            </validation-provider> -->

                <div class="locationcity">
                  <div class="w-full">
                    <div class="md:flex">
                      <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                        <p class="fsize14 input-title-black">
                          State<span class="text-red-500">*</span>
                        </p>
                        <el-select
                          v-model="selectedState"
                          filterable
                          placeholder="Select your state"
                          class="w-full border-0 cust-border"
                          @change="updateCities"
                        >
                          <el-option
                            v-for="state in states"
                            :key="state.name"
                            :label="state.name"
                            :value="state.name"
                          ></el-option>
                        </el-select>
                        <!-- <el-select
                          v-model="location"
                          placeholder="Select your state"
                          class="w-full border-0 cust-border"
                          :rules="{ required: true }"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select> -->
                        <!-- <base-input
                          v-model="location"
                          placeholder="Enter your location"
                          class="cust-form-border"
                          :rules="{ required: true }"
                          name="location"
                        ></base-input> -->
                        <!-- , alpha_num: true  -->
                      </div>
                      <div
                        class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full"
                      >
                        <p class="fsize14 input-title-black">
                          City<span class="text-red-500">*</span>
                        </p>
                        <el-select
                          v-model="selectedCity"
                          filterable
                          placeholder="Select your city"
                          class="w-full border-0 cust-border"
                          :disabled="!cities.length"
                        >
                          <el-option
                            v-for="city in cities"
                            :key="city.name"
                            :label="city.name"
                            :value="city.name"
                          ></el-option>
                        </el-select>
                        <!-- <base-input
                          v-model="city"
                          placeholder="Enter your city"
                          class="cust-form-border"
                          name="city"
                          :rules="{ required: true, alpha: true }"
                        ></base-input> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full">
                  <!-- <div class="pt-4 relative" v-if="showOtp"> -->
                  <div class="pt-4 relative">
                    <p class="fsize14 input-title-black">
                      Have a Referral Code?
                      <u
                        class="cursor-pointer ublue font-semibold"
                        @click="toggleReferral"
                        >Click Here</u
                      >
                    </p>
                    <base-input
                      v-if="showReferral"
                      name="referral"
                      v-model="referralCode"
                      placeholder="Enter Referral Code"
                      class="cust-form-border"
                    ></base-input>
                  </div>
                </div>

                <div class="locationcity">
                  <div class="pt-4 w-full">
                    <div class="md:flex">
                      <div class="">
                        <b-form-checkbox
                          :disabled="isValidForm"
                          id="checkbox-1"
                          v-model="status"
                        >
                          <p>
                            <strong>
                              <!-- {{ status }} -->
                              I have read and agreed to these
                              <u class="ublue" @click="editModal = true"
                                >terms and conditions</u
                              ></strong
                            >
                          </p></b-form-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <validation-provider
              :rules="{ required: true }"
              name="role"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  Which of the following do you identify with as being your
                  role?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="role"
                      name="role"
                      value="Prime Caregiver"
                      ><p>Primary Caregiver</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="role"
                      name="role"
                      value="Healthcare Proffesional"
                      ><p>Healthcare Professional</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="role"
                      name="role"
                      value="Have been a Caregiver"
                      ><p>Have been a Caregiver</p></b-form-radio
                    >
                  </div>
                </div>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="role"
                      name="role"
                      value="Will be a Caregiver"
                      ><p>Will be a Caregiver</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="role"
                      name="role"
                      value="Need Caregiving"
                      ><p>Need Caregiving</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="role"
                      name="role"
                      value="Well-wisher of a Caregiver"
                      ><p>Well-wisher of a Caregiver</p></b-form-radio
                    >
                  </div>
                </div>
              </div>
            </validation-provider> -->
                <!-- <div class="locationcity">
              <div class="pt-4 w-full">
                <div class="md:flex">
                  <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                    <p class="input-title-black">
                      How long have you been/were in this role for?
                    </p>
                    <base-input
                      v-model="experience"
                      placeholder=""
                      class="cust-form-border"
                      :rules="{ required: true, alpha_num: true }"
                      name="experience"
                    ></base-input>
                  </div>
                </div>
              </div>
            </div> -->
                <!-- <validation-provider
              :rules="{ required: true }"
              name="care"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  Who do you care for or who did you care for?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="careFor"
                      name="careFor"
                      value="Spouse/Partner"
                      ><p>Spouse/Partner</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="careFor"
                      name="careFor"
                      value="Parents"
                      ><p>Parents</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="careFor"
                      name="careFor"
                      value="Speial needs Child"
                      ><p>Special Needs Child</p></b-form-radio
                    >
                  </div>
                </div>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio v-model="careFor" name="careFor" value="Child"
                      ><p>Child</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="careFor"
                      name="careFor"
                      value="Sibling"
                      ><p>Sibling</p></b-form-radio
                    >
                  </div>
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="careFor"
                      name="careFor"
                      value="Friend"
                      ><p>Friend</p></b-form-radio
                    >
                  </div>
                </div>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="careFor"
                      name="careFor"
                      value="Grandparent"
                      ><p>Grandparent</p></b-form-radio
                    >
                  </div>
                </div>
              </div>
            </validation-provider> -->
                <!-- <div class="locationcity">
              <div class="pt-4 w-full">
                <div class="md:flex">
                  <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                    <p class="input-title-black">
                      What are the significant illness that you care receiver is
                      suffering from?
                    </p>
                    <base-input
                      v-model="illness"
                      placeholder=""
                      name="illness"
                      class="cust-form-border"
                      :rules="{ required: true, alpha_dash: true }"
                    ></base-input>
                  </div>
                </div>
              </div>
            </div> -->
                <!-- <validation-provider
              :rules="{ required: true }"
              name="areas"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  Which of the following areas do you need the most support?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="aligncheck">
                  <b-form-group>
                    <b-form-checkbox-group
                      id="checkbox-group-2"
                      v-model="area"
                      aria-describedby="ariaDescribedby"
                      name="flavour-1"
                    >
                      <div class="mt-4 md:flex justify-between items-center">
                        <div class="w-1/3">
                          <b-form-checkbox value="Social"
                            >Social</b-form-checkbox
                          >
                        </div>
                        <div class="w-1/3">
                          <b-form-checkbox value="Psychological"
                            >Psychological</b-form-checkbox
                          >
                        </div>
                        <div class="w-1/3">
                          <b-form-checkbox value="Physical"
                            >Physical</b-form-checkbox
                          >
                        </div>
                      </div>
                      <div class="mt-4 md:flex justify-between items-center">
                        <div class="w-1/3">
                          <b-form-checkbox value="Financial / Legal"
                            >Financial / Legal</b-form-checkbox
                          >
                        </div>
                        <div class="w-1/3">
                          <b-form-checkbox value="Spiritual"
                            >Spiritual</b-form-checkbox
                          >
                        </div>
                        <div class="w-1/3">
                          <b-form-checkbox value="Life / Work Purpose"
                            >Life / Work Purpose</b-form-checkbox
                          >
                        </div>
                      </div>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>
            </validation-provider> -->
                <!-- <validation-provider
              :rules="{ required: true }"
              name="support"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  How would you want to receiver information on caregiver
                  support?
                </p>
               <span 
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span> 
                <div class="aligncheck">
                  <b-form-group>
                    <b-form-checkbox-group
                      id="checkbox-group-1"
                      v-model="support"
                      aria-describedby="ariaDescribedby"
                      name="support"
                    >
                      <div class="mt-4 md:flex justify-between items-center">
                        <div class="w-1/3">
                          <b-form-checkbox value="One on One"
                            >One on One</b-form-checkbox
                          >
                        </div>
                        <div class="w-1/3">
                          <b-form-checkbox value="Email">Email</b-form-checkbox>
                        </div>
                        <div class="w-1/3">
                          <b-form-checkbox value="Whatsapp"
                            >Whatsapp</b-form-checkbox
                          >
                        </div>
                      </div>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div> 
                <div class="mt-4 md:flex justify-between">
            <div class="w-1/3">
              <b-form-radio
                v-model="support"
                
                name="support"
                value="Support Group"
                ><p>Support Group</p></b-form-radio
              >
            </div>
          </div> 
              </div>
            </validation-provider>  -->
                <!-- && status == '' -->
                <div>
                  <base-button
                    type="primary"
                    native-type="submit"
                    :disabled="!status"
                    class="w-full md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 border-2 text-base font-bold mt-8"
                    >Register</base-button
                  >
                </div>
                <span class="flex justify-center mt-4 font-bold subtitle"
                  >or</span
                >
                <!-- <div class="flex justify-center mt-4">
                  <div
                    class="btn-fb flex items-center m-2 border-4f0a4b cursor-pointer"
                    @click="getAuthUrl"
                  >
                    <div
                      class="bg-white mx-2 w-6 h-6 items-center justify-center flex"
                    >
                      <img
                        src="@/assets/images/Frame 2608204.png"
                        class=""
                        alt="Google"
                      />
                    </div>
                    <p
                      class="text18 font-semibold uppercase lg:px-4 md:px-4 px-2 py-2 text-white bg-0060fe"
                    >
                      SIGN UP WITH GOOGLE
                    </p>
                  </div>
                </div> -->
                <div class="lg:flex md:flex justify-center">
                  <div class="flex justify-center mb-0">
                    <div
                      class="flex items-center m-2 rounded-md border-primaryy"
                      @click="getAuthUrl"
                    >
                      <div
                        class="bg-white w-10 h-10 items-center justify-center rounded-full flex"
                      >
                        <img
                          src="@/assets/images/new/g-icon.png"
                          class="h-10 w-10 my-auto"
                          alt="Google"
                        />
                      </div>
                      <p
                        class="fsize14 font-semibold px-2 py-2 text-primary cursor-pointer"
                      >
                        Sign up with Google
                      </p>
                    </div>
                  </div>
                  <div class="flex justify-center mb-0">
                    <a :href="`${url}linkedin/`">
                      <div
                        class="flex items-center m-2 rounded-md border-primaryy"
                        @click="signUpLinkedIn"
                      >
                        <div
                          class="bg-white w-10 h-10 items-center justify-center rounded-full flex"
                        >
                          <img
                            src="@/assets/images/new/l-icon.png"
                            class="h-10 w-10 my-auto"
                            alt="Google"
                          />
                        </div>
                        <p
                          class="fsize14 font-semibold px-2 py-2 text-primary cursor-pointer"
                        >
                          Sign up with LinkedIn
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <!-- <div class="flex justify-center mb-0">
                  <div class="flex items-center m-2 rounded-md border-primaryy">
                    <div
                      class="bg-white w-10 h-10 items-center justify-center rounded-full flex"
                    >
                      <img
                        src="@/assets/images/new/w-icon.png"
                        class="h-10 w-10 my-auto"
                        alt="Google"
                      />
                    </div>
                    <p
                      class="fsize14 font-semibold px-2 py-2 text-primary cursor-pointer"
                    >
                      Continue with WhatsApp
                    </p>
                  </div>
                </div> -->
                <div class="flex justify-center">
                  <div id="otpless" class="w-240px"></div>
                </div>
              </b-form>
            </validation-observer>
            <div class="">
              <!-- <p class="text-base font-bold clr4F0A4B">Or register with</p>
          <div class="flex pt-4">
            <img
              src="./../../assets/images/logo/reg-google.svg"
              alt="google"
              class="mr-4"
            />
            <img
              src="./../../assets/images/logo/reg-fb.svg"
              alt="google"
              class="ml-4 mr-4"
            />
            <img
              src="./../../assets/images/logo/linkedin.svg"
              alt="google"
              class="ml-4"
            />
          </div> -->
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import RegisterImage from "./components/RegisterImage.vue";
import RegisterFormDetails from "./components/RegisterFormDetails.vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import emailMixin from "@/mixins/email";
import { mapState } from "vuex";
import { State, City } from "country-state-city";

export default {
  mixins: [emailMixin],

  data() {
    return {
      states: [],
      selectedState: "",
      cities: [],
      selectedCity: "",
      status: false,
      fname: "",
      lname: "",
      email: "",
      mobile: "",
      otp: "",
      verify: false,
      verified: false,
      time: 30000,
      OTPCountdown: false,
      countdownStarted: false,
      showOtp: false,
      password: "",
      age: "",
      occupation: "",
      location: "",
      city: "",
      role: "",
      experience: "",
      careFor: "",
      illness: "",
      area: [],
      support: [],
      value: "",
      isOpen: true,
      editModal: false,
      showReferral: false,
      referralCode: "",
      passwordFieldType: "password",
      url: this.$apiUrl,
      userExists: false,
    };
  },
  metaInfo: {
    title: "Register - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Welcome to Caregiver Saathi.Fill in your details to create your profile and access all the benefits.",
      },
    ],

    countryCode: "+91",
  },
  components: {
    countdown: VueCountdown,
    RegisterImage,
    RegisterFormDetails,
  },
  methods: {
    async verifyUser(val) {
      this.userExists = false;
      let payload;
      if (val == "email") {
        payload = {
          email: this.email.toLowerCase().trim(),
        };
      } else if (val == "mobile") {
        payload = {
          mobile: this.mobile,
        };
      }
      Object.assign(payload, { type: "register" });
      try {
        const getUser = await this.$store.dispatch("auth/getUser", payload);
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal
            .fire({
              title: "Error",
              text: error.response.data.message + " Enter new details ",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            })
            .then((result) => {
              if (
                error.response.data.message.includes("User already exists!")
              ) {
                this.userExists = true;
              }
              // if (
              //   error.response.data.message.includes(
              //     "Your account is in-active"
              //   )
              // ) {
              //   this.$router.push({ name: "account-active" });
              //   console.log("Move to activate account page");
              // }
            });
        }
      }
    },
    vendorRedirect() {
      this.$router.push({ name: "join-us", query: { partner: true } });
      // this.$bvModal.hide("vendorRegister");
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    toggleReferral() {
      this.showReferral = !this.showReferral;
    },

    async handleClick() {
      // this.verify = true;
      this.showOtp = true;
      this.OTPCountdown = true;
      const payload = {
        mobile: this.mobile,
        email: this.email.toLowerCase(),
        type: "Register",
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("auth/generateOTP", payload);
        this.$swal.fire({
          text: "OTP has been sent on Email and Mobile Please Verify",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
      } catch (error) {
        if ("Error") {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        this.handleCountdownEnd();
        loader.close();
      }
    },
    handleCountdownStart() {
      this.countdownStarted = true;
    },
    handleCountdownEnd() {
      this.countdownStarted = false;
      this.OTPCountdown = false;
    },
    register() {
      // this.$nextTick(() => {
      //   console.log("well");
      //   let elemInErrors = document.getElementsByClassName("is-invalid");
      //   console.log(elemInErrors);
      //   if (elemInErrors && elemInErrors.length > 0) {
      //     elemInErrors[0].scrollIntoView();
      //   }
      // });
      let payload = {
        firstname: this.fname,
        lastname: this.lname,
        mobile: this.mobile,
        email: this.email,
        role: "student",
        password: this.password,
        otp: this.otp,
        // age: this.age,
        // occupation: this.occupation,
        address: this.selectedState,
        city: this.selectedCity,
        // roleType: this.role,
        // experience: this.experience,
        // careFor: this.careFor,
        // illness: this.illness,
        // areas: this.area,
        // supportType: this.support,
        privacypolicy: "Accepted",
        countryCode: this.countryCode,
        // karmaCode: referralCode,
      };
      // console.log(payload);

      if (this.referralCode) {
        Object.assign(payload, { karmaCode: this.referralCode });
      }

      let loader = this.$loading();
      return new Promise(async (resolve, reject) => {
        try {
          const data = await this.$store.dispatch(
            "auth/signupWithPassword",
            payload
          );
          if (data.code == 200) {
            this.$router.push({ name: "home" });
            this.$swal.fire({
              title: "Registered Successfully",
              html: "<p style='text-align:center'>Discover more features! Check out our plans to find the best fit for you</p>",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            loader.close();
            // My Code start
            const bcc = ["ruchita.singhh@aiab.in"];
            const to = [this.email.toLowerCase()];
            const subject = "Welcome To Caregiversaathi! Sign-Up Successful";
            const message = `<html>
              <body>
                <div style="padding: 2rem; text-align: center;">
                  <img class="logo" src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/default/MicrosoftTeams-image%20(5)%20(1).png" alt="Caregiver Saathi Logo" style="height: 80px; width: auto;">
                </div>

                <div style="padding: 2rem; max-width: 780px; margin: auto; background-color: #ffffff; font-family: Arial, sans-serif; line-height: 1.6;">
                  <p>Hi ${this.fname},</p>

                  <p>Welcome to Caregiver Saathi!</p>

                  <p>Congratulations on joining Caregiver Saathi, a comprehensive ecosystem dedicated to the well-being of family caregivers. We are here to support those caring for loved ones navigating chronic medical conditions, old age, or terminal illness.</p>

                  <p>Our platform offers various resources, including emotional support, educational content, access to a community of experienced caregivers, support groups, counseling, and professional services for home-based care.</p>

                  <p>If you ever need more information or can't find what you're looking for, please reach out to us at <a href="mailto:info@caregiversaathi.co.in">info@caregiversaathi.co.in</a>.</p>

                  <p>Warm regards,</p>

                  <p>Team Caregiver Saathi<br/>
                  <a href="https://www.caregiversaathi.co.in" target="_blank">www.caregiversaathi.co.in</a></p>
                </div>

                <style>
                  .logo {
                    height: 80px;
                    width: auto;
                  }

                  body {
                    margin: 0;
                    padding: 0;
                    background-color: #f9f9f9;
                    color: #333;
                  }

                  a {
                    color: #007bff;
                    text-decoration: none;
                  }

                  a:hover {
                    text-decoration: underline;
                  }
                </style>
              </body>
              </html>
      `;
            await this.sendEmail(to, subject, message, [], bcc);
            this.$refs.formValidator.reset();

            // My Code End
          }
          resolve(data);
          loader.close();
        } catch (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message == "Student Already exists"
          ) {
            this.$swal.fire({
              text: "User Already Exists",
              confirmButtonText: "Okay",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          } else if ("Error") {
            this.$swal.fire({
              title: "Error",

              text: error.response.data.message,
              confirmButtonText: "Okay",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
          reject(error);
          loader.close();
        }
      });
    },
    handlesignin() {
      this.$router.push({ name: "signin" });
      window.localStorage.setItem("last-redirection", "register");
    },
    async addopenue() {
      isOpenLocal = true;
    },
    handleClose() {
      this.$emit("close");
    },
    async getAuthUrl() {
      try {
        this.$store.commit("auth/signinWith", "google");
        this.$store.commit("auth/loginAction", "signUp");
        let res = await this.$store.dispatch("google/getAuthUrl", {
          redirectURL: this.$homeAuth,
          scopes: ["profile", "email"],
        });
        window.open(res.data, "_self");
      } catch (error) {
        console.log(error);
        await this.errorPop();
      }
    },
    async signUpLinkedIn() {
      this.$store.commit("auth/signinWith", "linkedin");
    },
    // async signUpWhatsapp() {
    //   this.$store.commit("auth/signinWith", "whatsapp");
    // },
    async handleCountry({ name, iso2, dialCode }) {
      this.countryCode = `+${dialCode}`;
    },
    async errorPop() {
      return this.$swal({
        text: "Something went wrong. Please try again!!",
        icon: "warning",
        confirmButtonText: "Ok",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        showCloseButton: true,
      });
    },
    async signUpActionWhatsapp(firstName, mobile) {
      try {
        // let userInfo = await this.$store.dispatch("whatsapp/getUserInfo", {
        //   waId: waId,
        // });
        // console.log("WHATSAPP USERINFO:", userInfo);
        let payload = {
          firstname: firstName,
          mobile: mobile,
        };
        const { data } = await this.$store.dispatch(
          "auth/signUpWithWhatsapp",
          payload
        );
        // console.log("WHATSAPP DATA:", data);
        if (data) {
          // console.log("INSIDE DATA");
          this.$store.commit("auth/userData", data.user);
          const data1 = await this.$store.dispatch("eLearning/getProfile", {
            userId: data.user._id,
          });
          if (data.user.role == "volunteer") {
            const data2 = await this.$store.dispatch(
              "respitecare/get_volunteerbyuserid",
              {
                volunteerId: data.user._id,
              }
            );
          }
        }
        if (data.register === true) {
          // this.handleClose();
          this.$swal.fire({
            title: "Registered Successfully",
            html: "<p style='text-align:center'>Discover more features! Check out our plans to find the best fit for you</p>",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal.fire({
            // title: "Error",
            text: error.response.data.message,
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
            showCloseButton: true,
          });
        }
      }
    },
    updateCities() {
      // // Update cities based on selected state
      // console.log(this.selectedState, "selectedState");
      const selectedStateObj = this.states.find(
        (state) => state.name === this.selectedState
      );
      if (selectedStateObj) {
        this.cities = City.getCitiesOfState("IN", selectedStateObj.isoCode);
      } else {
        this.cities = [];
      }
      this.selectedCity = "";
    },
  },
  mounted() {
    // Define the 'otpless' function
    // ****************
    // window.otplessGetDiv();
    // window.otpless = async (otplessUser) => {
    //   const waName = otplessUser.waName;
    //   const waNumber = otplessUser.waNumber;
    //   // console.log("WHATSAPP USERDATA MOUNTED", waName, waNumber);
    //   if (waName && waNumber) {
    //     await this.signUpActionWhatsapp(waName, waNumber);
    //     this.$router.push({ name: "home" });
    //   }
    // };
    // ****************
    this.states = State.getStatesOfCountry("IN");
  },
  computed: {
    ...mapState("auth", ["signinWith"]),
    isInvalid() {
      return this.errors.any();
    },
    isValidForm() {
      if (this.otp == "") {
        return true;
      } else if (
        this.otp != "" &&
        this.fname != "" &&
        this.lname != "" &&
        this.mobile != "" &&
        this.password != "" &&
        this.email != "" &&
        this.selectedState != "" &&
        this.selectedCity != ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    // isdisabled() {
    //   console.log(this.status);
    //   if (this.status == "Accept our Privacy and Policy") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(val) {
        if (!val) {
          this.handleClose();
        }
      },
    },
  },
};
</script>
<style lang="scss">
.p-0card > .card-body {
  padding: 0px !important;
}

.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.root > div > .nav-tabs .nav-link {
  width: 220px;
  display: flex;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
    height: 60px;
  }
}
.root-il > div > .nav-tabs .nav-link {
  width: 120px;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
  }
}
/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.root-il > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root-il > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root-il > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root-il > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root-il > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.aligncheck .custom-control-label {
  padding-top: 4px;
}
.cust-form-border > fieldset > div > div > input {
  border: 2px solid #830c81;
}
.form-group {
  margin-bottom: 0px !important;
}
.ublue {
  color: rgb(86, 86, 248);
}
.bg-0060fe {
  background-color: #0060fe;
}
.border-4f0a4b {
  border: 0.5px solid gray;
}
.h-560px {
  height: 560px;
}
.cust-form-border > fieldset > div > div > input {
  border: 1px solid #830c81 !important;
}
.cust-border {
  border-radius: 6px !important;
  border: 1px solid #830c81 !important;
}
.vue-country-select {
  border-radius: 6px !important;
  border: 1px solid #830c81 !important;
  height: calc(1em + 1.35rem + 4px) !important;
}
.vue-country-select .dropdown {
  padding: 0.5em 12px !important;
}
.width15 {
  width: 15.5rem !important;
}
.btn-linkedin {
  background: #0a66c2;
  color: white;
}
.w-240px {
  width: 220px !important;
}

.h-360px {
  height: 360px;
}
</style>
